import { useEffect, useState } from 'react';
import { listEventPlayguideLinkSuggestions } from '../../api/playguides';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

type EventLike = { event_uuid?: unknown };

export default function useEventListPlayguideSuggestions({
  enabled,
  events,
}: {
  enabled: boolean;
  events: EventLike[];
}) {
  const [eventIds, setEventIds] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    if (!enabled) {
      setEventIds(new Set());
      return undefined;
    }
    const ids = Array.from(new Set(
      events
        .map((event) => String(event?.event_uuid || '').trim())
        .filter((eventUuid) => UUID_PATTERN.test(eventUuid))
    )).slice(0, 100);
    if (!ids.length) {
      setEventIds(new Set());
      return undefined;
    }
    let active = true;
    void listEventPlayguideLinkSuggestions(ids)
      .then((groups) => {
        if (!active) return;
        setEventIds(new Set(
          groups
            .filter((group) => Number(group.suggestionCount || 0) > 0)
            .map((group) => group.eventUuid)
        ));
      })
      .catch(() => {
        // 一覧の補助表示なので、背景取得の一過性失敗は無音にする。
        if (active) setEventIds(new Set());
      });
    return () => { active = false; };
  }, [enabled, events]);

  return eventIds;
}
